import { render } from "./AttachmentInternalLink.vue?vue&type=template&id=55f3a4ef&scoped=true&ts=true&lang=pug"
import script from "./AttachmentInternalLink.vue?vue&type=script&lang=ts"
export * from "./AttachmentInternalLink.vue?vue&type=script&lang=ts"

import "./AttachmentInternalLink.vue?vue&type=style&index=0&id=55f3a4ef&lang=scss&scoped=true"

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f3a4ef"]])

export default __exports__